var React = require('react');

function SendEmailsEasily (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"8","fill":"#064861","key":0}),React.createElement("mask",{"id":"mask0_5595_2120","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"12","y":"12","width":"24","height":"24","key":1},React.createElement("rect",{"x":"12","y":"12","width":"24","height":"24","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_5595_2120)","key":2},React.createElement("path",{"d":"M15 32V16L34 24L15 32ZM17 29L28.85 24L17 19V22.5L23 24L17 25.5V29Z","fill":"#FFD301"}))]);
}

SendEmailsEasily.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = SendEmailsEasily;

SendEmailsEasily.default = SendEmailsEasily;
